import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";

import Blyth from "../../../assets/img/blog/on/Blyth.webp"; 
import elliot from "../../../assets/img/blog/on/elliot.webp"; 
import sandy from "../../../assets/img/blog/on/sandy.webp"; 
import sandy01 from "../../../assets/img/blog/on/sandy01.webp"; 
import wheeler04 from "../../../assets/img/blog/on/wheeler04.webp"; 
import wheeler03 from "../../../assets/img/blog/on/wheeler03.webp"; 
import whiteMeadowns from "../../../assets/img/blog/on/white.webp"; 

const MAPLE_REGIONS = [
  {
    id: "gta",
    region: "Toronto GTA",
    farms: [
     {
        name: "Elliot Tree Farm",
        img: elliot,
        description: "A family-run farm in Toronto offering a classic maple season experience with a pancake house, maple syrup tastings, and walking trails through the sugar bush. Visitors can learn about traditional maple syrup production while enjoying fresh maple treats in a scenic countryside setting.",
        location: "9467 Erin East Garafraxa Townline, Hillsburgh, ON N0B 1Z0",
        website: "Elliot Tree Farm",
        webUrl: "https://elliotttreefarm.ca/",
        dates: "every weekend through April 5 (March 16, 20 and April 3rd), 2026"
      },
      {
        name: "Brooks Farms",
        description: "A popular family farm near Toronto offering maple syrup tours, wagon rides, pancake breakfasts, and maple tastings during its annual Maplefest celebration.",
        location: "122 Ashworth Rd, Mount Albert, ON L0G 1M0",
        website: "Brooks Farms",
        webUrl: "https://www.brooksfarms.com/maplesugarfestival",
        dates: "March 7 – April 19, 2026 (Maplefest weekends and March Break)"
      },
      {
        name: "Purple Woods Maple Syrup Festival",
        description: "One of the GTA’s most well-known maple festivals features guided sugarbush tours, historical syrup-making demonstrations, and maple taffy on snow.",
        location: "38 Coates Rd E, Oshawa, ON L1H 7K4",
        website: "Purple Woods Maple Syrup Festival",
        webUrl: "https://www.cloca.com/maple-syrup-festival",
        dates: "March, 2026 (Check official website for exact dates)"
      },
      {
        name: "Pefferlaw Creek Farms",
        description: "A family-friendly maple farm offering tapping tours, sugar shack demonstrations, maple taffy on snow, and pancake meals with fresh local ingredients.",
        location: "12300 Concession Rd 6, Uxbridge, ON L9P 1R4",
        website: "Pefferlaw Creek Farms",
        webUrl: "https://www.pcfarms.ca/",
        dates: "March 7 – April 19, 2026 (Check official website for exact dates)"
      },
      {
        name: "Drysdale’s Tree Farm",
        description: "A fourth-generation tree farm about an hour north of Toronto that hosts an annual maple festival featuring sugarbush tours, maple syrup demonstrations, horse-drawn wagon rides, pancake breakfasts, and maple treats for families.",
        location: "6635 Simcoe County Rd 56, Egbert, ON L0L 1N0",
        website: "Drysdale’s Tree Farm",
        webUrl: "https://www.drysdalestreefarm.com/",
        dates: "March 20, 21 & 22, 2026 "
      },
      {
        name: "Fort Rose Maple Company",
        description: "A family-owned maple farm in Ontario offering sugar bush tours, wagon rides, and a popular pancake house serving fresh maple syrup during the maple season. Visitors can learn how sap is collected and boiled into syrup while enjoying classic maple breakfast dishes.",
        location: "27382 Coldstream Rd, Parkhill, ON N0M 2K0, Canada",
        website: "Fort Rose Maple Company",
        webUrl: "https://fortrose.ca/flyer/",
        dates: "February 21 – March 29, 2026 (Pancake brunches and maple tours typically run on weekends during maple season)"
      }
    ]
  },
  {
    id: "eastern-ontario",
    region: "Eastern Ontario Maple Farms",
    farms: [
    {
        name: "Sandy Flat Sugar Bush",
        img: sandy01,
        description: "A rustic sugar bush experience where visitors can explore forest trails, watch maple syrup being made, and enjoy fresh maple treats.",
        location: "2017 Concession 6, Perth, ON K7H 3C9",
        website: "Sandy Flat Sugar Bush",
        webUrl: "https://www.sandyflatsugarbush.com/",
        dates: "March, 2026 (Check official website for exact dates)"
      },
        {
        name: "Wheeler’s Maple Products",
        description: "A historic maple farm featuring the Maple Heritage Museum, maple syrup tastings, and scenic forest trails in the Lanark Highlands.",
        location: "1001 Highland Line Rd, Lanark, ON K0G 1K0",
        website: "Wheeler’s Maple Products",
        webUrl: "https://wheelersmaple.com/",
        dates: "February 28 - April 26, 2026 (Check official website for exact dates)"
      },

      {
        name: "Fulton’s Sugar Bush & Maple Shop",
        description: "One of Eastern Ontario’s most famous sugar bushes offering sleigh rides, maple taffy on snow, forest trails, and maple syrup demonstrations.",
        location: "399 Sugar Bush Rd, Pakenham, ON K0A 2X0",
        website: "Fulton’s Sugar Bush & Maple Shop",
        webUrl: "https://www.fultons.ca/",
        dates: "February 28 – April 19, 2026 (Check official website for exact dates)"
      },
      {
        name: "Fortune Farms Sugar Bush",
        description: "A family-run sugar bush known for maple syrup tastings, educational tours, and traditional pancake meals during maple season.",
        location: "1313 Blakeney Rd, Pakenham, ON K0A 2X0",
        website: "Fortune Farms Sugar Bush",
        webUrl: "https://fortunefarms.ca/",
        dates: "March 7 until the end of the season"
      },
      {
        name: "Temple’s Sugar Bush",
        description: "A charming maple farm offering guided sugarbush tours, maple syrup tastings, and traditional pancake house meals.",
        location: "1700 Ferguson Falls Rd, Lanark Highlands, ON K0G 1K0",
        website: "Temple’s Sugar Bush",
        webUrl: "https://www.templessugarbush.ca/",
        dates: "March 4 – mid April, 2026 (Check official website for exact dates)"
      },
      {
        name: "Sand Road Sugar Camp",
        description: "A traditional sugar camp offering maple taffy on snow, wagon rides, and classic sugar shack meals during maple season.",
        location: "19279 Sand Rd, Athens, ON K0E 1B0",
        website: "Sand Road Sugar Camp",
        webUrl: "https://www.sandroadsugarcamp.com/",
        dates: "March – April 19, 2026 (Check official website for exact dates)"
      }
    ]
  },
  {
    id: "muskoka-maple-farms",
    region: "Muskoka Maple Farms",
    farms: [
      {
        name: "Sugarbush Hill Maple Farm",
        img: wheeler03,
        description: "A Muskoka maple farm offering guided tours where visitors can learn about maple syrup production and enjoy fresh maple tastings.",
        location: "2392 Brunel Rd, Huntsville, ON P1H 2J3",
        website: "Sugarbush Hill Maple Farm",
        webUrl: "https://www.sugarbushhill.com/",
        dates: "April, 2026 (Check official website for exact dates)"
      },
      {
        name: "Wintergreen Maple Products",
        description: "A small-batch maple syrup producer in Muskoka offering traditional maple products and seasonal syrup-making demonstrations.",
        location: "2284 Hwy 118 W, Bracebridge, ON P1L 1W9",
        website: "Wintergreen Maple Products",
        webUrl: "http://www.wintergreenmapleproducts.com/",
        dates: "March – April, 2026 (Check official website for exact dates)"
      }
    ]
  },
  {
    id: "niagara-region",
    region: "Niagara Region Maple Farms",
    farms: [
      {
        name: "White Meadows Farms",
        img: whiteMeadowns,
        description: "A well-known Niagara sugar bush featuring maple syrup tours, pancake houses, maple taffy demonstrations, and family-friendly farm activities.",
        location: "2519 Effingham St, St. Catharines, ON L2R 6P7",
        website: "White Meadows Farms",
        webUrl: "https://whitemeadowsfarms.com/",
        date: "February 28 - April 12, 2026 (Check official website for exact dates)"
      },
      {
        name: "Agape Valley Sugar Bush",
        description: "A scenic maple farm in the Niagara region offering wagon rides, maple tastings, and sugarbush tours during the spring maple season.",
        location: "20047 Niagara Pkwy, Niagara-on-the-Lake, ON L0S 1J0",
        website: "Agape Valley Sugar Bush",
        webUrl:"https://www.agapevalley.ca/",
        date: "March 7, 14, 21 & 28, 2026"
      }
    ]
  },
  {
    id: "other-ontario-maple-farms",
    region: "Other Ontario Maple Farms Worth Visiting",
    farms: [
      {
        name: "Blyth Creek Maple Farm",
        img: Blyth,
        description: "A rural maple farm producing small-batch maple syrup and offering authentic countryside maple experiences.",
        location: "42232 Moncrieff Rd, Blyth, ON N0M 1H0",
        website: "Blyth Creek Maple Farm",
        webUrl: "https://www.blythcreekmaplefarm.com/",
        dates: "March – April, 2026 (Check official website for exact dates)"
      },
      {
        name: "Kinsmen Fanshawe Sugar Bush",
        description: "A popular seasonal maple festival held in Fanshawe Conservation Area, offering sugar bush tours, maple syrup boiling demonstrations, maple taffy on snow, and family-friendly outdoor activities during the spring sugaring season.",
        location: "21201 c Lakeside Dr, Thorndale, ON N0M 2P0",
        website: "Kinsmen Fanshawe Sugar Bush",
        webUrl: "https://www.kinsmenfanshawesugarbush.com/",
        dates: "March, 2026 (Check official website for exact dates)"
      },
      {
        name: "Maple Tap Farm",
        description: "A small maple farm specializing in handcrafted maple syrup and seasonal farm experiences during the sugaring season.",
        location: "1654 Queen St, New Dundee, ON N0B 2E0",
        website: "Maple Tap Farm",
        webUrl: "https://www.mapletapfarm.ca/",
        dates: "March 21 & 22 – April 11, 2026"
      },
      {
        name: "Hogan’s Homestead",
        description: "A Northern Ontario maple farm known for its large sugar bush with over 30,000 tapped trees. Visitors can explore the sugar shack, watch maple syrup being boiled, join snowshoe tours of the forest, and shop a variety of pure and infused maple products.",
        location: "1157 Thielman Rd, Goulais River, ON P0S 1E0, Canada",
        website: "Hogan’s Homestead",
        webUrl: "https://www.hoganshomestead.ca/",
        dates: "Feb 25 – April 30, 2026  (Check official website for exact dates)"
      }
    ]
  }

];

export default function MapleSyrupON() {
  return (
    <div className={styles.page}>
      {/* Top meta like blogTO */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>Travel</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti Team</span>
        <span className={styles["sep"]}>•</span>
        <span>February 11, 2025</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>Best Maple Syrup Farms in Ontario (2026 Guide)</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={wheeler04}
          alt="Maple Syrup Festival"
        />
      </div>

    <div className={styles["lead-section"]}>
        
    <p><strong>Experience Maple Season at the Best Maple Farms in Ontario</strong><br /></p>
    
    <p>Spring in Ontario means maple season. As winter begins to fade and temperatures slowly rise, maple syrup farms across Ontario open their sugar bushes for visitors eager to experience one of Canada’s sweetest traditions.</p>
    <p>Whether you're planning a weekend trip to a maple farm near Toronto or exploring scenic countryside sugar bushes across the province, visiting a maple farm is one of the best ways to celebrate spring.</p>

    <p>Visitors can watch how sap is collected from sugar maple trees and boiled down into rich, golden syrup while exploring beautiful maple forests. Many farms offer maple syrup tastings, pancake houses, sugar bush tours, and demonstrations of traditional syrup-making techniques.</p>

    <p>Beyond the syrup itself, maple season is a fun outdoor experience for families and visitors alike. From wagon rides and forest walks to maple taffy on snow and warm pancake breakfasts, visiting a maple syrup farm in Ontario is one of the most delicious ways to welcome spring.</p>

    <p>Ready to explore? We’ve rounded up some of the best maple farms in Ontario, including several popular maple syrup farms near Toronto, where you can experience the magic of the 2026 maple season.</p>

    <p><strong>🗓 Maple Season:</strong> Late February to April 2026<br />
    Bring your appetite and enjoy one of Canada’s most iconic seasonal traditions.</p>

    </div>

      <div className={styles["jump-links"]}>
        {MAPLE_REGIONS.map((region, idx) => (
          <React.Fragment key={region.id}>
            <a href={`#${region.id}`}>{region.region}</a>
            {idx < MAPLE_REGIONS.length - 1 && <span> | </span>}
          </React.Fragment>
        ))}
      </div>

      {MAPLE_REGIONS.map((region) => (
        <div key={region.id} id={region.id}>
          <h2 className={styles["region-title"]}>{region.region}</h2>
          <hr className={styles["region-divider"]} />
          
          {region.farms.map((farm, fIdx) => (
            <div key={fIdx} className={styles["farm-section"]}>
              <h3 className={styles["farm-name"]}>{farm.name}</h3>
              <hr className={styles["region-divider"]} />
              
              {farm.img && (
                <img
                  src={farm.img}
                  alt={farm.name}
                  className={styles["farm-image"]}
                  style={(() => {
                    if (farm.img === elliot) {
                      return {
                        objectPosition: "center 25%", // move crop window upward
                      };
                    }

                    if (farm.img === whiteMeadowns || farm.img === sandy01) {
                      return {
                        objectPosition: "center 65%", // move crop window downward
                      };
                    }

                    return undefined;
                  })()}
                />
              )}
              
              <div className={styles["farm-description"]}>
                <p>{farm.description}</p>
              </div>

              <div className={styles["event-details-title"]}>Event Details:</div>
              <ul className={styles["details-list"]}>
                <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Location:</span> {farm.location}
                </li>
                {farm.dates && (
                    <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Dates:</span> {farm.dates}
                    </li>
                )}
                {farm.website && (
                  <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Website:</span><br />
                    <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                      {farm.website}
                    </a>
                  </li>
                )}
              </ul>
              <hr className={styles["farm-divider"]} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
